<template>
  <div>
    <dp-application-common-form
        ref="commonForm"
        v-model="dpApplicationForm.commonForm"
    />
    <dp-application-applicant-form-list
        ref="applicantFormList"
        v-if="useAuthnStore().isConstructionManager"
        v-model="dpApplicationForm.applicantForms"
        :template-fields="dpApplicationForm.nonCommonTemplateFields"
    />
    <vg-card ref="agreement" class="no-padding hidden" style="padding-bottom: 30px">
      <dp-tenant-agreement v-if="isTenant" v-model="agreeAgreement"/>
      <dp-construction-agreement v-else v-model="agreeAgreement"/>
    </vg-card>
    <vg-button-group-fixed>
      <vg-button
          class="primary"
          @click="submitApplication"
          :loading="submitButtonLoading"
          loading-text="提交中..."
      >
        提交
      </vg-button>
    </vg-button-group-fixed>
  </div>
</template>

<script>
import {client} from "@/libraries/http";
import {Toast} from "vant";
import DpApplicationApplicantFormList
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpApplicationApplicantFormList.vue";
import DpApplicationCommonForm
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpApplicationCommonForm.vue";
import useDpApplicationFormStore from "@/store/dp-application-form-store";
import VgButtonGroupFixed from "@/components/Commons/VgButtonGroupFixed.vue";
import VgButton from "@/components/Commons/VgButton.vue";
import VgCard from "@/components/Commons/VgCard.vue";
import useAuthnStore from "@/store/authn";
import DpConstructionAgreement
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpConstructionAgreement.vue";
import DpTenantAgreement from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpTenantAgreement.vue";
import {mapState} from "pinia";

export default {
  name: "DigitalPassApplicationsForm",
  components: {
    DpTenantAgreement,
    DpConstructionAgreement,
    VgCard,
    VgButton,
    VgButtonGroupFixed,
    DpApplicationCommonForm,
    DpApplicationApplicantFormList
  },
  data() {
    return {
      agreeAgreement: false,
      submitButtonLoading: false,
      noticeTenant: "1.请正确填写本人信息；\n" +
          "2.租户员工登记后会获得电子出入证，出入商场或夜间加班请主动配合保安进行例行检查。\n" +
          "3.请在电子出入证有效期结束前最后一周前往物业管理中心续期。\n",
      noticeConstruction: "1.若由于施工人员及单位资料手续不齐全，管理中心有权拒绝办理。\n",
    }
  },
  created() {
    useDpApplicationFormStore().loadCache(this.applicationSituationId)
    useDpApplicationFormStore().init(this.applicationSituationId)
  },
  destroyed() {
    useDpApplicationFormStore().closeCache()
  },
  computed: {
    ...mapState(useAuthnStore, ['isTenant']),
    dpApplicationForm() {
      return useDpApplicationFormStore()
    },
    passCardType() {
      return this.dpApplicationForm.passCardType;
    },
    applicationSituationId() {
      return this.$route.params.applicationSituationId
    },
    projectId() {
      return this.dpApplicationForm.projectId;
    }
  },
  watch: {
    passCardType() {
      useDpApplicationFormStore().init(this.applicationSituationId)
    },
    projectId() {
      useDpApplicationFormStore().init(this.applicationSituationId)
    },
  },
  methods: {
    useAuthnStore,
    validate() {
      return Promise.all([
        ...this.$refs.commonForm.validate(),
        ...this.$refs.applicantFormList?.validate() ?? []
      ])
    },
    submitApplication() {
      this.validate()
          .then(() => {
            if (!this.agreeAgreement) {
              return Promise.reject({
                ref: this.$refs.agreement,
                message: '请先阅读并同意《电子出入证申请须知》'
              });
            }
          })
          .then(() => {
            this.submitButtonLoading = true
            return this.requestCreateOrUpdate()
          })
          .then((res) => {
            return new Promise(resolve => {
              useDpApplicationFormStore().clearCache()
              this.$toast.success({
                message: '提交成功',
                duration: 500,
                onClose: () => resolve(res)
              })
            })
          })
          .then(res => {
            return this.submitJump(res.data);
          })
          .catch((e) => {
            if (e?.ref) {
              Toast(e.message)
              e?.ref.$el.scrollIntoView({
                behavior: "smooth",  // 平滑过渡
                block: 'center', //居中
              })
            }
          })
          .finally(() => {
            this.submitButtonLoading = false
          })
    },
    requestCreateOrUpdate() {
      const fieldToDto = field => ({id: field.id, value: field.value})
      const formToDto = form => ({fields: form.fields.map(fieldToDto)})

      const form = {
        passCardType: this.passCardType,
        commonForm: formToDto(this.dpApplicationForm.commonForm),
        applicantForms: this.dpApplicationForm.applicantForms.map(formToDto)
      }

      return this.applicationSituationId
          ? client.put(`/api/h5/digital-passes/applications/${this.applicationSituationId}`, form,
              {
                headers: {
                  'Toast-Message': encodeURI('提交中...')
                }
              })
          : client.post('/api/h5/digital-passes/applications/', form,
              {
                headers: {
                  'Toast-Message': encodeURI('提交中...')
                }
              })
    },
    submitJump(data) {
      if (data.passCardStatus === 'PENDING_PAYMENT') {
        if (!data.orderCode) {
          // 获取费用失败，不跳转到支付
          return new Promise(resolve => {
            this.$toast.fail({
              message: '获取工本费失败，请联系相关营运人员',
              onClose: () => resolve()
            })
          }).then(() => {
            this.$router.replace({path: '/digital-passes/applications'});
          })
        } else {
          this.$router.replace({
            path: '/scanVerify/chargePay', query: {
              orderNo: data.orderCode,
              orderAmount: data.paymentAmount
            }
          });
        }
      } else if (data.passCardStatus === 'COMPLETED') {
        this.$router.replace({path: '/myElectronicPass'});
      } else {
        this.$router.go(-1)
      }
      return Promise.resolve()
    },
  }
}
</script>

<style scoped>
.addPhotoDiv {
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  width: 100px;
  height: 100px;
  text-align: center;
}

.imgClass {
  float: right;
}

.imgClass >>> .van-uploader__preview-delete {
  background: red;
  top: -6px;
  right: -6px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
}

.tenant-personnel {
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 20px 15px;
}

.app .tenant-personnel-eq-applicant {
  border: 0px;
  border-radius: 0px;
  margin: 0px;
}
</style>